export default __webpack_public_path__ + "static/media/component-menu.418bd949.png";